import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

export interface ChildrenItems {
    state: string;
    name: string;
    type?: string;
    path?: string;
}

export interface Menu {
    state: string;
    name: string;
    type: string;
    icon: string;
    children?: ChildrenItems[];
}

const MENUITEMS = [
    {
        state: 'impersonate',
        name: 'Impersonate',
        type: 'main-link',
        icon: 'account_tree'
    },
    /*{
        state: 'leads',
        name: 'Leads',
        type: 'main-link',
        icon: 'filter_alt'
    },*/
    {
        state: 'merchants',
        name: 'Merchants',
        type: 'main-link',
        icon: 'contacts'
    },
    {
        state: 'statements',
        name: 'Statements',
        type: 'main-link',
        icon: 'request_quote'
    },
    {
        state: 'proposals',
        name: 'Proposals',
        type: 'main-link',
        icon: 'summarize'
    },
    {
        state: 'self-service-reviews',
        name: 'Self-Service Manual Reviews',
        type: 'main-link',
        icon: 'pending_actions'
    },
    {
        state: 'billing',
        name: 'Billing',
        type: 'main-link',
        icon: 'receipt_long'
    },
    {
        state: 'organization-settings',
        name: 'Organization Settings',
        type: 'org-sub',
        icon: 'settings',
        children: [
            {
                state: 'organization-management',
                name: 'Organization Management'
            },
            {
                state: 'organization-users',
                name: 'User Management'
            },
            {
                state: 'organization-billing',
                name: 'Billing'
            },
            // {
            //     state: 'organization-advanced',
            //     name: 'Advanced'
            // },
            /*{
                state: 'organization-lead-gen',
                name: 'Lead Generation'
            }*/
        ]
    },
    {
        state: 'admin',
        name: 'Admin',
        type: 'admin-sub',
        icon: 'admin_panel_settings',
        children: [
            {
                state: 'statement-reviews',
                name: 'Statement Reviews'
            },
            {
                state: 'registration-approval',
                name: 'Registration Approval'
            },
            {
                state: 'users',
                name: 'User Management'
            },
            {
                state: 'client-management',
                name: 'Client Management'
            },
            {
                state: 'billing-management',
                name: 'Billing Management'
            }
        ]
    },
    {
        state: 'trial-users',
        name: 'User Management',
        type: 'trial-link',
        icon: 'supervisor_account'
    },
    {
        state: 'upgrade-account',
        name: 'Upgrade Account',
        type: 'trial-link',
        icon: 'upgrade'
    },
    {
        state: 'portal',
        name: 'Portal',
        type: 'portal',
        icon: 'attach_money',
        children: [
            {
                state: 'merchants',
                name: 'Merchants',
                path: `${environment.portalUrl}/merchants`,
            },
            {
                state: 'virtual-terminal',
                name: 'Virtual Terminal',
                path: `${environment.portalUrl}/merchants/terminal`
            },
            {
                state: 'pci-portal',
                name: 'PCI Portal',
                path: `${environment.portalUrl}/merchants/pci-portal`
            },
            {
                state: 'statements',
                name: 'Statements',
                path: `${environment.portalUrl}/merchants/statements`
            },
            {
                state: 'customer-vault',
                name: 'Customer Vault',
                path: `${environment.portalUrl}/customer-vault`
            },
            {
                state: 'chat-center',
                name: 'Chat Center',
                path: `${environment.portalUrl}/support/chat-center`
            },
            {
                state: 'settings',
                name: 'Settings',
                path: `${environment.portalUrl}/merchants/settings`
            }
        ]
    },
    {
        state: 'support',
        name: 'Support',
        type: 'main-link',
        icon: 'support'
    }
];

@Injectable()
export class MenuItems {
    getAll(): Menu[] {
        return MENUITEMS;
    }

    add(menu: any) {
        MENUITEMS.push(menu);
    }
}
